import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Layout.css';
import { useLocation } from 'react-router-dom';

import {
  faHome,
  faChalkboardTeacher,
  faCalendarAlt,
  faCertificate,
  faMoneyBillWave,
  faUser,
  faBars,
  faCog,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const Layout = ({ children }) => {  
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  
  useEffect(() => {
    if (location.pathname.includes('/sales/Dashboard')) {
      setActiveTab('dashboard');
    } else if (location.pathname.includes('/sales/myclasses')) {
      setActiveTab('classes');
    } else if (location.pathname.includes('/sales/myschedule')) {
      setActiveTab('schedule');
    } else if (location.pathname.includes('/sales/curriculum')) {
      setActiveTab('Curriculum');
    } else if (location.pathname.includes('/sales/myearnings')) {
      setActiveTab('Earnings');
    } else if (location.pathname.includes('/sales/mystudents')) {
      setActiveTab('Students');
    } else if (location.pathname.includes('/sales/settings')) {
      setActiveTab('settings');
    }
  }, [location.pathname]);
  
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const storedToken = localStorage.getItem('userData');
  const userToken = storedToken ? JSON.parse(storedToken) : null;
  
  useEffect(() => {
    if (!userToken) return;

    const storedData = localStorage.getItem('userData');
    const userData = storedData ? JSON.parse(storedData) : null;
    if (!userData) {
      navigate('/login');
      return;
    }
  

    const sendHeartbeat = async () => {
      try {
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/verify`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            IdStudent: userToken.id,
          }),
        });
      } catch (error) {
        console.error('Heartbeat failed:', error);
      }
    };

    const fetchUserData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/teacher/layout`, {
          headers: {
            'Authorization': `Bearer ${userData}`,
            'Content-Type': 'application/json'
          }
        });
  
        if (!response.ok) {
          throw new Error('Unauthorized');
        }
  
        const data = await response.json();
        setUserData({
          id: data.id,
          username: data.username,
          firstName: data.firstName,
          lastName: data.lastName,
          Image: data.Image,
          fullName: `${data.firstName} ${data.lastName}`
        });
  
      } catch (error) {
        console.error('Failed to fetch user data:', error);
        navigate('/login');
      }
    };
  
    fetchUserData();
    sendHeartbeat(); // Initial call
    const intervalId = setInterval(sendHeartbeat, 30000); // Every 30s

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [navigate, userToken]);

  const handleLogout = () => {
    localStorage.removeItem('userData');
    navigate('/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="sales-portal-layout">
      {/* Logout Confirmation Modal */}
      <Modal
        isOpen={showLogoutModal}
        onRequestClose={() => setShowLogoutModal(false)}
        contentLabel="Logout Confirmation"
        className="sales-portal-logout-modal"
        overlayClassName="sales-portal-logout-modal-overlay"
      >
        <div className="sales-portal-modal-content">
          <h3>Are you sure you want to logout?</h3>
          <div className="sales-portal-modal-buttons">
            <button 
              className="sales-portal-cancel-button"
              onClick={() => setShowLogoutModal(false)}
            >
              Cancel
            </button>
            <button 
              className="sales-portal-confirm-button"
              onClick={handleLogout}
            >
              Yes, Logout
            </button>
          </div>
        </div>
      </Modal>

      {/* Fixed Top Navigation Bar */}
      <nav className="sales-portal-top-navbar">
        <div className="sales-portal-navbar-left">
          <button className="sales-portal-sidebar-toggle" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="sales-portal-logo">
            <img src="../../assets/img/logo/logonew.png" alt="RoboMind Logo" />
          </div>
        </div>
        
        <div className="sales-portal-navbar-right">
          <div className="sales-portal-user-profile-mini">
            <div className="sales-portal-user-avatar">
              {userData?.fullName ? userData.fullName.charAt(0).toUpperCase() : 'T'}
            </div>
            <span>{userData?.fullName || 'Teacher'}</span>
          </div>
        </div>
      </nav>

      <div className="sales-portal-content-wrapper">
        {/* Sidebar */}
        <div className={`sales-portal-sidebar ${sidebarOpen ? 'sales-portal-open' : ''}`}>
          <div className="sales-portal-user-profile">
            <img 
              src={userData?.Image || "../../assets/img/student.jpg"} 
              alt="User profile" 
              className="sales-portal-avatar" 
            />
            <div className="sales-portal-user-info">
              <h4>{userData?.fullName || 'Teacher Name'}</h4>
              <p>Sales Coordinator</p>
            </div>
          </div>

          <nav className="sales-portal-sidebar-nav">
            <ul>
              <li className={activeTab === 'dashboard' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('dashboard');
                navigate('/sales/dashboard');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>
                <FontAwesomeIcon icon={faHome} />
                <span>Dashboard</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li className={activeTab === 'classes' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('classes');
                navigate('/sales/myclasses');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>                
                <FontAwesomeIcon icon={faChalkboardTeacher} />
                <span>My Classes</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li className={activeTab === 'schedule' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('schedule');
                navigate('/sales/myschedule');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>                
                <FontAwesomeIcon icon={faCalendarAlt} />
                <span>My Schedule</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li className={activeTab === 'Curriculum' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('Curriculum');
                navigate('/sales/curriculum');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>
                <FontAwesomeIcon icon={faCertificate} />
                <span>Curriculum</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li className={activeTab === 'Earnings' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('Earnings');
                navigate('/sales/myearnings');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>
                <FontAwesomeIcon icon={faMoneyBillWave} />
                <span>My Earnings</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li className={activeTab === 'Students' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('Students');
                navigate('/sales/mystudents');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>
                <FontAwesomeIcon icon={faUser} />
                <span>My Students</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li className={activeTab === 'users' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('users');
                navigate('/sales/users');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>                
                <FontAwesomeIcon icon={faUser} />
                <span>Users</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li className={activeTab === 'allclasses' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('allclasses');
                navigate('/sales/allclasses');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>
                <FontAwesomeIcon icon={faUser} />
                <span>All Classes</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
            </ul>
          </nav>

          <div className="sales-portal-sidebar-footer">
            <ul>
              <li className={activeTab === 'settings' ? 'sales-portal-active' : ''} onClick={() => {
                setActiveTab('settings');
                navigate('/teacher/settings');
                if (window.innerWidth <= 768) {
                  setSidebarOpen(false);
                }
              }}>
                <FontAwesomeIcon icon={faCog} />
                <span>Settings</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
              <li onClick={() => setShowLogoutModal(true)}>
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span>Logout</span>
                <div className="sales-portal-active-indicator"></div>
              </li>
            </ul>
          </div>
        </div>

        {/* Main Content */}
        <div onClick={() => setSidebarOpen(false)} className={`sales-portal-main-content ${sidebarOpen ? 'sales-portal-shifted' : ''}`}>
          {React.cloneElement(children, { userData })}
        </div>
      </div>
    </div>
  );
};

export default Layout;